module.exports = __webpack_public_path__ + "static/img/routine-intro-alt.36afd3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/score/routine-intro-alt.jpg
// module id = /Dsr
// module chunks = 0